import { InboxPage } from '@/features/notifications/pages/InboxPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/$wsSlug/inbox')({
  component: InboxPage,
});
